import { Checkbox } from "@mui/material";
import React, { useContext, useMemo } from "react";

import { inject } from "../../../../../../../../lib/itn-ui-kit/services/service-container";
import DataContext from "../../../../../../../context/DataContext";

import { getFormattedPrice } from "./helpers";

const ApptBillsList = ({
  bills,
  selectedBills,
  setSelectedBills,
  isDeleteMode = false,
  locked = false,
}) => {
  const currentUserService = inject("current-user-service");
  const { userType } = useContext(DataContext);
  const canEdit = currentUserService?.userRoles?.permissions.includes(
    "provider.change_administeredservices"
  );
  const canDelete = currentUserService?.userRoles?.permissions.includes(
    "provider.delete_administeredservices"
  );
  const isAuthorizedProvider = useMemo(
    () => userType !== "Provider" && (canEdit || canDelete) && !locked,
    [userType, canEdit, canDelete, locked]
  );
  const gridCols = isDeleteMode ? "grid-cols-5" : "grid-cols-[40px_1fr_1fr_1fr_1fr_1fr]";

  function formatDate(bill) {
    if (bill?.updated_at) {
      return new Date(bill.updated_at).toLocaleString();
    }
    if (bill?.created_at) {
      return new Date(bill.created_at).toLocaleString();
    }
    return "N/A";
  }

  function handleCheckedItems(checked, bill) {
    if (checked) {
      setSelectedBills?.((prev) => [...prev, bill]);
    } else {
      setSelectedBills?.((prev) => [...prev.filter((element) => element.pk !== bill.pk)]);
    }
  }

  return (
    <>
      {bills?.length > 0 ? (
        <>
          {/* Header */}
          <div className={`grid w-full items-center ${gridCols} mb-2 gap-4 font-semibold`}>
            {!isDeleteMode && <div id="checkbox"></div>}
            <div className="flex h-full w-full flex-wrap place-content-center overflow-x-hidden p-2">
              CPT Code
            </div>
            <div className="flex h-full w-full flex-wrap place-content-center overflow-x-hidden p-2">
              CPT Description
            </div>
            <div className="flex h-full w-full flex-wrap place-content-center overflow-x-hidden p-2">
              Amount
            </div>
            <div className="flex h-full w-full flex-wrap place-content-center overflow-x-hidden p-2">
              Last Update/Created Time
            </div>
            <div className="flex h-full w-full flex-wrap place-content-center overflow-x-hidden p-2">
              {" "}
              Last Update/Created By
            </div>
          </div>
          <>
            {/* Body */}
            {bills.map((bill, idx) => (
              <div key={idx} className={`grid w-full items-center ${gridCols} mb-4 gap-4`}>
                {!isDeleteMode && (
                  <div className="flex h-full w-full flex-wrap place-content-center p-2">
                    <Checkbox
                      checked={selectedBills?.some((item) => item.pk === bill.pk)}
                      disabled={!isAuthorizedProvider}
                      onChange={(_, checked) => handleCheckedItems(checked, bill)}
                      className="p-0 hover:bg-transparent"
                    />
                  </div>
                )}
                <div className="flex h-full w-full flex-wrap place-content-center overflow-x-hidden border-r-2 border-gray-200 p-2">
                  {bill.service?.service_code || "N/A"}
                </div>
                <div className="flex h-full w-full flex-wrap place-content-center overflow-x-hidden border-r-2 border-gray-200 p-2">
                  {bill.service?.service_name || "N/A"}
                </div>
                <div className="flex h-full w-full flex-wrap place-content-center overflow-x-hidden border-r-2 border-gray-200 p-2">
                  {getFormattedPrice(bill.price)}
                </div>
                <div className="flex h-full w-full flex-wrap place-content-center overflow-x-hidden border-r-2 border-gray-200 p-2">
                  {formatDate(bill)}
                </div>
                <div className="flex h-full w-full flex-wrap place-content-center overflow-x-hidden p-2">
                  {bill?.updated_by?.name ?? bill?.created_by?.name ?? "N/A"}
                </div>
              </div>
            ))}
          </>
        </>
      ) : (
        <div className="mt-6 rounded-lg bg-gray-200 p-4 text-center">
          <h3>No Administered Services Found</h3>
        </div>
      )}
    </>
  );
};

export default ApptBillsList;
